import bus from "/src/utils/event_bus";
import { watch } from 'vue';
import { useSessionStore } from "@/stores/session";
import { useAppStore } from "@/stores/app";
import { useSelectedStore } from "@/stores/selected";
import { useConstructiblesStore } from "@/stores/constructibles";
import router from '/src/router'


// WATCHERS THAT LAUNCH ACTIONS FROM SESSION STATE CHANGES


export const init_session_watchers = function () {
    const session_store = useSessionStore()
    const app_store = useAppStore()
    const selected_store = useSelectedStore()
    const constructibles_store = useConstructiblesStore()

    // The units the viewer holds, loaded again the way they were loaded: by
    // project, or by date company-wide. Company-wide without a date nothing is
    // loaded, and nothing is reloaded.
    const reloadUnits = () => {
        const pr_uuid = selected_store.selected_project?.uuid
        if (pr_uuid && pr_uuid != "all") {
            constructibles_store.loadAssemblies(pr_uuid)
            constructibles_store.loadModules(pr_uuid)
        } else if (app_store.byDateModeActive && selected_store.selected_date != "2000-01-01") {
            constructibles_store.loadAssembliesByDate(selected_store.selected_date)
            constructibles_store.loadModulesByDate(selected_store.selected_date)
        }
    }

    // When the selected production line changes, redirect based on tipos
    watch(
        () => session_store.selected_line_uuid,
        (newLine, oldLine) => {
            if (newLine === oldLine) return
            if (!session_store.iam_prod_worker) return

            // Units are filtered by line on the server and batches are not, so
            // the new line's batches would show up empty until the project is
            // opened again. `undefined` is the user object arriving at login,
            // not a change.
            if (oldLine !== undefined) reloadUnits()
            if (!newLine) return

            if (session_store.pl_only_logistics_tipos) {
                // Only logistics tipos → go to logistics
                const project_uuid = selected_store.selected_project?.uuid
                if (project_uuid && project_uuid !== 'all') {
                    router.push({ name: 'logistics', params: { project_uuid } })
                } else {
                    router.push({ name: 'company_logistics' })
                }
            } else if (session_store.pl_has_production_tipos) {
                // Has production tipos → go to viewer (if currently in logistics)
                if (app_store.app_mode === 'logistics') {
                    app_store.setViewerMode()
                    router.push({ name: 'viewer' })
                }
            }
        }
    )

    session_store.$subscribe((mutation, state) => {
        console.log("🍍👁️ Empty watchers for session store.")
    })

    bus.on("events/session/logout", () => {
        session_store.cleanSession()
        // Keep where the user was going. Without this, a token that expired mid-flow
        // sends them to the login page and then drops them somewhere else entirely,
        // which is what broke the OAuth consent flow: the whole authorization
        // request lived in that URL.
        const back = router.currentRoute.value?.fullPath
        const query = back && !back.startsWith("/login") ? { redirect: back } : {}
        router.push({ name: 'login', query })
            .catch(() => console.log("[!] Can't go to login. Maybe already in login page."))
    })

}